module.exports = __webpack_public_path__ + "static/img/A1.e813107.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/SuperAce/A1.png
// module id = 9CMx
// module chunks = 0